// extracted by mini-css-extract-plugin
module.exports = {"customTooltip":"CustomTooltip_customTooltip__yQ14t"};